exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".returnAccountHeader .inner{border:1px solid #e8cb36;border-radius:5px;padding:10px 30px}.returnAccountHeader .leftSection{display:inline-block;vertical-align:middle;width:65%}.returnAccountHeader .rightSection{display:inline-block;vertical-align:middle;width:33%;border-left:1px solid #ccc;text-align:center}.returnAccountHeader .rightSection a:nth-of-type(2){color:#555}.returnAccountHeader .demoImg{width:auto;height:40px;margin-right:15px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/layout/return_account_header.scss
// module id = 852
// module chunks = 0